import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inputRef", "placeholder", "onKeyDown", "maxRows", "aria-describedby"];
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Textarea from 'react-textarea-autosize';
import { KEY } from 'utils/ui/constants';
import { textInputStyle, textInputProps } from 'components/TextInput';
import { useFormFieldContext } from 'components/FormField';
var shouldForwardProp = function shouldForwardProp(prop) {
  return !textInputProps.includes(prop);
};
export var StyledTextarea = styled(Textarea).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "TextArea__StyledTextarea",
  componentId: "sc-ecivc-0"
})(["", " min-height:41px;"], textInputStyle);
var TextArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var inputRef = _ref.inputRef,
    placeholder = _ref.placeholder,
    onKeyDown = _ref.onKeyDown,
    maxRows = _ref.maxRows,
    ariaDescribedBy = _ref['aria-describedby'],
    otherProps = _objectWithoutProperties(_ref, _excluded);
  function handleTextareaKeyDown(e) {
    var target = e.target;
    if (e.key === KEY.ENTER && e.metaKey) {
      var _target$form;
      target === null || target === void 0 ? void 0 : (_target$form = target.form) === null || _target$form === void 0 ? void 0 : _target$form.requestSubmit();
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  }
  var _useFormFieldContext = useFormFieldContext({
      id: otherProps.id,
      required: otherProps.required,
      descriptionIds: ariaDescribedBy
    }),
    id = _useFormFieldContext.id,
    required = _useFormFieldContext.required,
    horizontal = _useFormFieldContext.horizontal,
    descriptionIds = _useFormFieldContext.descriptionIds;
  return /*#__PURE__*/React.createElement(StyledTextarea, _extends({}, otherProps, {
    ref: ref || inputRef,
    id: id,
    required: required,
    "aria-describedby": descriptionIds
    // Safari has a [bug](https://bugs.webkit.org/show_bug.cgi?id=142968) where
    // empty input fields do not align correctly with baseline alignment.
    // Adding a "one space" placeholder fixes the issue.
    ,
    placeholder: horizontal ? placeholder || ' ' : placeholder,
    onKeyDown: handleTextareaKeyDown,
    maxRows: maxRows
  }));
});
TextArea.displayName = 'TextArea';
export default TextArea;